import React, { useState } from 'react';
import SeeratUnNabiLectures from './Seerat-Un-Nabi-Lectures'
import MondayDarsLectures from './MondayDarsLectures'

const TABS = [
  { key: 'seerat', label: 'Seerat un Nabi' },
  { key: 'namaaz', label: 'Namaaz e Nabwi' },
  { key: 'monday', label: 'Monday Dars' },
];

const Card = () => {
  const [activeTab, setActiveTab] = useState('');

  return (
    <div className="lectures-content">
      <div className="lectures-tabs">
        {TABS.map(tab => (
          <button
            key={tab.key}
            className={`lectures-tab${activeTab === tab.key ? ' lectures-tab-active' : ''}`}
            onClick={() => setActiveTab(tab.key)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {activeTab === '' && (
        <div className="lectures-empty">
          <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#bbb" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9 18V5l12-2v13"/><circle cx="6" cy="18" r="3"/><circle cx="18" cy="16" r="3"/>
          </svg>
          <p>Select a lecture series above to get started</p>
        </div>
      )}

      {activeTab === 'seerat' && <SeeratUnNabiLectures />}

      {activeTab === 'namaaz' && (
        <div className="lectures-empty">
          <p>Currently no lectures here</p>
        </div>
      )}

      {activeTab === 'monday' && <MondayDarsLectures />}
    </div>
  );
};

export default Card;
